import { getDefaultKindSelectState } from "../../components/antd/kindselect/KindSelect";
import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { getDefaultBaseInput, OptimisticConcurrency } from "../../schema/types/base";
import { ServiceAccountCreate } from "../../schema/types/serviceAccount/create";
import { ServiceAccount } from "../../schema/types/serviceAccount/entity";
import { ServiceAccountInput } from "../../schema/types/serviceAccount/input";

export function getDefaultServiceAccountInput(): ServiceAccountInput {
  return {
    ...getDefaultBaseInput(),
    id: "",
    version: 0,
    group: getDefaultKindSelectState(),
    meta: {
      isEdit: false,
    },
  };
}

export function inputToServiceAccount(input: ServiceAccountInput): ServiceAccountCreate {
  const res: ServiceAccountCreate = {
    name: input.name,
    kind: "serviceaccount",
    tags: inputToTags(input.tags),
    origin: "default",
  };
  if (input.description) {
    res.description = input.description;
  }
  return res;
}

export function serviceAccountToInput(serviceAccount: ServiceAccount): ServiceAccountInput {
  const def = getDefaultServiceAccountInput();
  const res: ServiceAccountInput = {
    ...def,
    id: serviceAccount.id,
    version: serviceAccount.version,
    name: serviceAccount.name,
    description: serviceAccount.description,
    tags: tagsToInput(serviceAccount.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };
  return res;
}

export function serviceAccountToPatch(_serviceAccount: ServiceAccountCreate, concurrency: OptimisticConcurrency) {
  const serviceAccount: any = JSON.parse(JSON.stringify(_serviceAccount));

  serviceAccount[`$replace/tags`] = serviceAccount.tags;
  delete serviceAccount.tags;

  serviceAccount.id = concurrency.id;
  serviceAccount.version = concurrency.version;

  return serviceAccount;
}
